import {
  CatalogTable,
  CatalogTableColumnsFunc,
  CatalogTableRow,
} from '@backstage/plugin-catalog';
import { TableColumn } from '@backstage/core-components';

const START_DATE_ANNOTATION = 'datamarx.com/start-date';

const dateStartedColumn: TableColumn<CatalogTableRow> = {
  title: 'Date Started',
  customSort: (a, b) => {
    // ISO dates sort correctly as strings
    const aDate = a.entity.metadata.annotations?.[START_DATE_ANNOTATION] ?? '';
    const bDate = b.entity.metadata.annotations?.[START_DATE_ANNOTATION] ?? '';
    return aDate.localeCompare(bDate);
  },
  render: row => {
    const dateStr = row.entity.metadata.annotations?.[START_DATE_ANNOTATION];
    if (!dateStr) return '—';
    return new Date(`${dateStr}T12:00:00Z`).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC',
    });
  },
};

export const catalogColumnsFunc: CatalogTableColumnsFunc = context => {
  if (context.filters.kind?.value === 'user') {
    const { columns } = CatalogTable;
    return [
      columns.createTitleColumn({ hidden: true }),
      columns.createNameColumn({ defaultKind: 'user' }),
      columns.createMetadataDescriptionColumn(),
      dateStartedColumn,
      columns.createTagsColumn(),
    ];
  }
  return CatalogTable.defaultColumnsFunc(context);
};
